import { useEffect, useState } from 'react';

export function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    function onScroll() {
      setVisible(window.scrollY > 600);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;
  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Back to top"
      className="fixed bottom-6 right-6 z-40 rounded-full border border-gold-400/60 bg-ink-950/90 px-3 py-2 font-display text-[11px] uppercase tracking-[0.22em] text-gold-300 shadow-lg backdrop-blur hover:border-gold-300 hover:text-gold-200"
    >
      ↑ Top
    </button>
  );
}
